module.exports = __webpack_public_path__ + "img/1.ccf2cf12.png";